import React from "react";
import { boundError } from "../../../utils";

const CardStyleBtnRaw = ({ children }) => {
  return <div className="card-button-container">{children}</div>;
};

export const CardStyleBtn = boundError(CardStyleBtnRaw);
